const routeConstant = {
    login: {
        path: '/',
        title: 'Login'
    },
    forgot: {
        path: '/forgot',
        title: 'forgot Password'
    },
    otp: {
        path: '/otp',
        title: 'Verify OTP'
    },
    resetPassword: {
        path: '/reset',
        title: 'Reset Password'
    },
    user: {
        task: {
            path: '/allTask',
            title: 'ALL Task'
        },
        wopt: {
            path: '/wopt',
            title: 'Work On Processing Task'
        }
    },
    admin: {
        dashboard: {
            path: '/dashboard',
            title: 'Dashboard'
        },
        roughListing: {
            list: {
                path: '/rough-listing/list',
                title: 'Manage Rough Listing'
            },
            addrl: {
                path: '/rough-listing/add',
                title: 'Add Rough Listing'
            },
            viewrl: {
                path: '/rough-listing/view',
                title: 'View Rough Listing'
            }
        },
        po: {
            list: {
                path: '/po/list',
                title: 'Manage Purchase Order'
            },
            addpo: {
                path: '/po/addpurchaeOrder',
                title: 'Add Purchase Order'
            },
            viewpo: {
                path: '/po/viewpo',
                title: 'View Purchase Order'
            }
        },
        so: {
            list: {
                path: '/so/list',
                title: 'Manage Sale Order'
            },
            addso: {
                path: '/so/addsaleOrder',
                title: 'Add Sale Order'
            },
            viewso: {
                path: '/so/viewso',
                title: 'View Sale Order'
            }
        },
        inventory: {
            list: {
                path: '/inventory/list',
                title: 'Manage GMR'
            },
            detailinventory: {
                path: '/inventory/detail',
                title: 'Detail Inventory'
            },
            upinventory: {
                path: '/inventory/upinventory',
                title: 'Update Inventory'
            }
        },
        manageUser: {
            path: '/user',
            title: 'Manage User'
        },
        manageTask: {
            path: '/task',
            title: 'Manage Task'
        },
        manageProduct: {
            path: '/product',
            title: 'Manage Product'
        },
        manageCategory: {
            path: '/category',
            title: 'Manage Category'
        },
        manageSubCategory: {
            path: '/sub-category',
            title: 'Manage Category'
        },
        internalTransfer: {
            list: {
                path: '/internal_transfer/list',
                title: 'Internal Transfer'
            },
            addit: {
                path: '/internal_transfer/addit',
                title: 'Add Internal Transfer'
            },
            viewit: {
                path: '/internal_transfer/viewit',
                title: 'View Internal Transfer'
            }
        },
        returnOrder: {
            list: {
                path: '/return/list',
                title: 'Manage Return List'
            },
            addreturn: {
                path: '/return/addreturn',
                title: 'Add Return Order'
            },
            viewreturn: {
                path: '/return/viewreturn',
                title: 'View Return Order'
            }
        },
        matchProducts: {
            list: {
                path: '/match-products/list',
                title: 'Match Products'
            }
        },
        qrCodes: {
            list: {
                path: '/qr-codes',
                title: 'QR Code Management'
            }
        }
    },
    projectDetail: {
        users: {
            path: '/project/:id/user',
            title: 'Manage User'
        },
        mileStones: {
            path: '/project/:id/milestones',
            title: 'Milestones'
        },
        documents: {
            path: '/project/:id/documents',
            title: 'Documents'
        },
        externalLinks: {
            path: '/project/:id/external',
            title: 'External Links'
        },
        integrations: {
            path: '/project/:id/integrations',
            title: 'Integrations'
        },
        resources: {
            path: '/project/:id/resources',
            title: 'Resources'
        },
        notes: {
            path: '/project/:id/notes',
            title: 'Notes'
        },
        activity: {
            path: '/project/:id/activity',
            title: 'Activity'
        },
        settings: {
            path: '/project/:id/settings',
            title: 'Settings'
        }
    },
};
export { routeConstant };
